/**
 * @generated SignedSource<<31a8a4951c7121a64b6f3bf9945fad03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AccountType = "ProductLed" | "SalesLed";
import { FragmentRefs } from "relay-runtime";
export type editLeadStrategyForm_AccountFragment$data = {
  readonly extension: {
    readonly accountType?: AccountType | null;
    readonly domain?: string | null;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "editLeadStrategyForm_AccountFragment";
};
export type editLeadStrategyForm_AccountFragment$key = {
  readonly " $data"?: editLeadStrategyForm_AccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editLeadStrategyForm_AccountFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editLeadStrategyForm_AccountFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "accountExtensionKind",
          "value": "Tka"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accountType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "domain",
              "storageKey": null
            }
          ],
          "type": "TkaAccountExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(accountExtensionKind:\"Tka\")"
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "5bb1b5017e48e464cf4772c1c5a3f6d7";

export default node;
